const style = {
  mainContainer: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    padding: 6,
    width: '100%',
  },
  simpleColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  simpleRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  dateLabel: {
    fontWeight: 700,
    fontSize: 14,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  minorText: {
    fontSize: 12,
    paddingRight: 10,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

export default style;
